export const ANNUAL_REPORT_STEP_SIGNED = "ANNUAL_REPORT_STEP_SIGNED";